<template>
  <BaseForm
    lang="en"
    :close="handleClose"
    :open-message="handleOpenMessage"
    container-class="modal-question-form-body--question"
    banner-class="modal-question-form-banner--question"
    inputs-container-class="modal-question-form__inputs--question"
    checkbox-container-class="styled-checkbox--question"
    :translations="translations"
    :show-banner-image="false"
    :show-company-url="false"
    :show-plans-count="false"
    :show-question="true"
    :show-house-icon="false"
    form-type="question"/>
</template>

<script setup>
import { ref } from 'vue';
import BaseForm from '@/Components/En/Modals/BaseForm.vue';

const translations = ref({
  en: {
    name_placeholder: 'Name*',
    email_placeholder: 'Email*',
    privacy: 'By clicking “Send,” I agree to the <a href="/privacy-policy" class="link" target="_blank">processing of my personal data</a>. Learn more in our <a href="/privacy-policy" class="link" target="_blank">Privacy Policy</a>',
    question_placeholder: 'Question',
    send: 'Send',
    title: 'Ask your questions',
    subtitle: 'Our team assists you to find the best way to use AI Getfloorplan',
  },
  ru: {
    name_placeholder: 'Имя*',
    email_placeholder: 'Электронная почта*',
    privacy: 'Нажимая кнопку «Отправить», я даю согласие на <a href="/agreement" class="link" target="_blank">обработку персональных данных</a>. Узнать больше о <a href="/privacy-policy" class="link" target="_blank">политике конфиденциальности</a>',
    question_placeholder: 'Вопрос*',
    send: 'Отправить',
    title: 'Задайте ваш вопрос',
    subtitle: 'Расскажем обо всех возможностях нашего ИИ',
  },
});
</script>
